import { type FC } from "react";

export const Price: FC<{
  /** The price in cents */
  price: number;
}> = ({ price }) => <span>${(price / 100).toFixed(2)}</span>;
